import {getScale, getTopValue, splitIDs} from '../GelDragDrop.utils';
import {GEL_TYPE, CELL_TYPE} from '../GelDragDrop.constants';

export function getStyle({state, props}) {
  const scale = getScale(state);
  const height = getHeight(state.gelHolderBoxHeight, props.height);
  return {
    height: `${height}px`,
    left: '10%',
    top: `${getTopValue(scale(props.value), state) - (height / 2)}px`,
    width: '80%',
    opacity: props.opacity,
    fontSize: `${getFontSize(height, props)}px`,
  };
}

const MAX_HEIGHT_VALUE = 100;
function getHeight(gelHolderBoxHeight, propHeight) {
  return (gelHolderBoxHeight * propHeight) / MAX_HEIGHT_VALUE - 2;
}

function getFontSize(height, props) {
  if (props.gelType === GEL_TYPE.LABEL) return 16;
  else return height - 1;
}

const CELL_IDS = {
  1: CELL_TYPE.GEL_HOLDER,
  2: CELL_TYPE.GEL_PATH,
  3: CELL_TYPE.TRASH_CAN,
};

export function getCellTypeFromID(gelId) {
  const cellId = splitIDs(gelId)[1];
  return {cellType: CELL_IDS[cellId], cellId};
}

export function getNextClipValue(clipValues, currentValue) {
  let index = clipValues.findIndex((clipValue) => clipValue === currentValue);
  return clipValues[index + 1];
}
export function getPreviousClipValue(clipValues, currentValue) {
  let index = clipValues.findIndex((clipValue) => clipValue === currentValue);
  return clipValues[index - 1];
}
